import { render, staticRenderFns } from "./Definir.vue?vue&type=template&id=4e28d42a&scoped=true&"
import script from "./Definir.vue?vue&type=script&lang=js&"
export * from "./Definir.vue?vue&type=script&lang=js&"
import style0 from "./Definir.vue?vue&type=style&index=0&id=4e28d42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e28d42a",
  null
  
)

export default component.exports